import React, { KeyboardEventHandler, useEffect, useState } from "react";
import { Input, InputGroup } from "rsuite";
interface Props {
  defaultValue?: string;
  placeholder?: string;
  onChange?: any;
  value?: any;
  isValidate?: boolean;
  onKeyPress?: KeyboardEventHandler<HTMLInputElement> | undefined;
  textType?: React.ElementType<any> | undefined;
  rows?: number;
  type?: string;
  regexPattern?: RegExp;
  maxlength?: number;
  minlength?: number;
  style?: object;
  label?: string;
  disabled?: boolean;
  hasError?: boolean;
  data?: any;
  totalLength?: number;
  onDoubleClick?: any;
  title?: string;
  ref?: any;
  onBlur?: any;
}

export const EPInput: React.FC<Props> = ({
  isValidate,
  placeholder,
  onChange,
  value,
  defaultValue,
  onKeyPress,
  textType,
  rows,
  type,
  maxlength,
  regexPattern,
  minlength,
  label,
  disabled,
  hasError,
  data,
  totalLength,
  onDoubleClick,
  title,
  ref,
  onBlur
}) => {
  const [delay, setDelay] = useState(false);
  // useEffect(() => {
  //   console.log(defaultValue,"<<<<<D")
  //   setTimeout(() => {

  //     delay?setDelay(false):setDelay(true)
  //   }, 250);

  // }, [defaultValue])
  return (
    <>
      {" "}
      {
        <Input
          onDoubleClick={onDoubleClick}
          disabled={disabled}
          as={textType}
          type={type}
          rows={rows}
          title={title}
          maxLength={maxlength || totalLength}
          minLength={minlength || totalLength}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={(value, event) => {
            onChange(value, event);
          }}
          ref={ref}
          onBlur={onBlur}
          className={
            (value === undefined &&
              label === "interviewFeedback" &&
              isValidate) ||
            (value === undefined && isValidate) ||
            (typeof value === "string" && value?.trim() === "" && isValidate) ||
            (typeof value === "string" &&
              value?.trim() === "" &&
              value !== "") ||
            (minlength && value?.length < minlength && isValidate) ||
            (maxlength && value?.length > maxlength && isValidate) ||
            (regexPattern && !regexPattern.test(value) && isValidate) ||
            (totalLength && value?.length !== totalLength && isValidate) ||
            (type === "file" && isValidate && value === null)
              ? "border border-danger"
              : ""
          }
          pattern={regexPattern && regexPattern.toString()}
        />
      }
    </>
  );
};
